import { render, staticRenderFns } from "./psSettlementApply.vue?vue&type=template&id=703594bf&scoped=true"
import script from "./psSettlementApply.vue?vue&type=script&lang=js"
export * from "./psSettlementApply.vue?vue&type=script&lang=js"
import style0 from "./psSettlementApply.vue?vue&type=style&index=0&id=703594bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703594bf",
  null
  
)

export default component.exports